export default __webpack_public_path__ + "static/media/0237.53fab75b.jpg";